import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import checkTrialExpiration from "../services/checkTrialExpiration";
import Preloader from "./Preloader";
import Sidebar from "./Sidebar";

const ProtectedLayout = () => {
  const { user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    const verifyAccess = async () => {
      if (!user) return;

      try {
        await checkTrialExpiration();

        const db = getFirestore();
        const userRef = doc(db, "registeredUsers", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const data = userSnap.data();
          if (data.subscriptionStatus === "expired") {
            setAccessDenied(true);
          }
        }
      } catch (err) {
        console.error("Error en verificación de suscripción:", err);
      } finally {
        setChecking(false);
      }
    };

    verifyAccess();
  }, [user]);

  if (checking)
    return (
      <div className="preloaderFullScreen">
        <Preloader />
      </div>
    );
  if (accessDenied) return <Navigate to="/access-denied" replace />;

  return (
    <>
      <Sidebar />
      <Outlet />
    </>
  );
};

export default ProtectedLayout;
